import { gql } from '@apollo/client';

export const CREATE_NSC_SUBJECT_DATAS = gql`
  mutation createNSCSubjectDatas($inputs: [CreateNSCSubjectDataInput!]!) {
    subjects: createNSCSubjectDatas(inputs: $inputs) {
      id
    }
  }
`;
